module.exports = __webpack_public_path__ + "img/ticket3_pl.7d4bf74a.svg";